export default function assertExhaustive(x: never): never {
  throw new Error(`Reached unknown type in union: ${x}`);
}
